"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundType = void 0;
/**
 * The rounding method that should be used.
 */
var RoundType;
(function (RoundType) {
    /**
     * Always round down to the nearest value.
     * Positive numbers get smaller or stay the same.
     * Example Precision 1: 0.123 becomes 0.1
     * Negative numbers get smaller or stay the same.
     * Example Precision 1: -0.123 becomes -0.2
     */
    RoundType["FLOOR"] = "floor";
    /**
     * Always round up to the nearest value.
     * Positive numbers get larger or stay the same.
     * Example Precision 1: 0.123 becomes 0.2
     * Negative numbers get larger or stay the same.
     * Example Precision 1: -0.123 becomes -0.1
     */
    RoundType["CEIL"] = "ceil";
    /**
     * Always round to the nearest value.
     * Example Precision 1: 0.123 becomes 0.1
     * Example Precision 1: -0.123 becomes -0.1
     * Example Precision 1: 0.163 becomes 0.2
     * Example Precision 1: -0.163 becomes -0.2
     */
    RoundType["ROUND"] = "round";
    /**
     * Always round the absolute value down to the nearest value.
     * Positive numbers get smaller or stay the same.
     * Example Precision 1: 0.123 becomes 0.1
     * Negative numbers get larger or stay the same.
     * Example Precision 1: -0.123 becomes -0.1
     */
    RoundType["FLOOR_ABSOLUTE_VALUE"] = "floor absolute value";
    /**
     * Always round the absolute value up to the nearest value.
     * Positive numbers get larger or stay the same.
     * Example Precision 1: 0.123 becomes 0.2
     * Negative numbers get smaller or stay the same.
     * Example Precision 1: -0.123 becomes -0.2
     */
    RoundType["CEIL_ABSOLUTE_VALUE"] = "ceil absolute value";
})(RoundType = exports.RoundType || (exports.RoundType = {}));
//# sourceMappingURL=RoundType.js.map